import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router";
import { useNavigate } from "react-router-dom";
import Cookies from "universal-cookie";
import { setToken } from "../redux/Auth/authSlice";
import { useDispatch } from "react-redux";

//elements
import Login from "../Auth/Login";
import FormGemo from "../Page/Gemo/FormGemo";
import FormOnco from "../Page/Onco/FormOnco";
import AdminGemo from "../Admin/GemoMed/AdminGemo";
import OncoAdmin from "../Admin/Oncomed/OncoAdmin";
import Admin from "../Admin/Admin";
import Check from "../Page/Onco/Check";
import SuperAdmin from "../Admin/SuperAdmin/SuperAdmin";

function Index() {
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const navigate = useNavigate();
  const token = cookies.get("token");
  const role = window.localStorage.getItem("role");

  useEffect(() => {
    if (token !== undefined) {
      navigate("/");
    }
    dispatch(setToken({ token }));
    //   setLoader(true);
    //   setTimeout(() => {
    //     setLoader(false);
    //   }, 3000);
  }, [token]);
  return (
    <>
      {token === undefined  ? (
        <Routes>
          <Route path="/" element={<Login />} />
          <Route path="*" element={<Login />} />
          <Route path="/onco" element={<FormOnco />} />
          <Route path="/oncocheck" element={<Check />} />
          <Route path="/gemo" element={<FormGemo />} />
        </Routes>
      ) : (
        <div className="router">
          <Admin />
          <Routes>
            <Route path="/" element={<OncoAdmin />} />
            <Route path="/adminGemo" element={<AdminGemo />} />
            {role === "SuperAdmin" ? (
              <Route path="/superAdmin" element={<SuperAdmin />} />
            ) : (
              ""
            )}
          </Routes>
        </div>
      )}
    </>
  );
}

export default Index;
